var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[(_vm.displayFooter && !_vm.$route.meta.headless)?_c('customized-footer'):_vm._e(),_vm._v(" "),_c('portal-target',{attrs:{"name":"BwFooterExtraCopyRights"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }